var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73477 9.64034L2.40132 16.9738C2.04764 17.3274 1.47422 17.3274 1.12058 16.9738L0.265254 16.1184C-0.0878259 15.7653 -0.0885054 15.1931 0.263745 14.8392L6.07563 8.99995L0.263745 3.16075C-0.0885054 2.80684 -0.0878259 2.2346 0.265254 1.88152L1.12058 1.0262C1.47426 0.67251 2.04767 0.67251 2.40132 1.0262L9.73477 8.35956C10.0884 8.71325 10.0884 9.28666 9.73477 9.64034Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.08ad2e3059e00fcd2098a84c98bbed3b.svg";
export { ForwardRef as ReactComponent };